import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;

  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 768px){
    padding: 16px;
  }

  .input-wrapper{
    width: 90%;
  }

  .bordas{
    width: 100%;
    margin-bottom: 20px;
    padding: 20px;
    border: solid 1px #c5cbd6;
    border-radius: 8px;
  }

  .arquivos{
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    label{
      font-size: smaller;
      width: 100%;
      margin-left: 5px;
      text-align: center;
      color: #8a92a2;
    }
    .btn-update{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 30px;
      border: dashed 1px #8a92a2;
      border-radius: 8px;
    }
    .arq-name{
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        transform: rotate(45deg);
        z-index: 10;
      }

      img:hover{
        cursor: pointer;
      }
    }
  }
  
  .legenda {
    font-size: smaller;
    width: 100%;
    margin-left: 5px;
    text-align: center;
  }

  .button-finish {
    justify-content: space-around;
    flex-direction: row;
    align-items: center;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  max-width: 880px;

  gap: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;

  >div{
    padding: 0;
  }

  >div>div{
    max-width: 880px;

    >div{
      max-width: 100%;
      padding: 8px 0;

      >div>div{
        padding: 0;

        >div>form{
          margin-top: 0;

          >div>input{
            &:-webkit-autofill {
              -webkit-box-shadow: 0 0 0 30px white inset;
            }
          }

          @media (max-width: 990px){
            >div:nth-of-type(2), 
            >div:nth-of-type(4){
                margin-bottom: 40px;

              >div:last-of-type{
                justify-content: space-between;
              }
            }
          }
        }
      }
    }
  }
`;

export const ContainerContentAcordionClose = styled.div`
    width: 100%;
    height: auto;

    gap: 48px;
    display: flex;
    justify-content: center;
    justify-content: flex-start;
`;

export const InformationAcordionClose = styled.div`
    width: auto;
    height: auto;

    gap: 8px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
`;

export const ContainerCpntentAcordionCard = styled.div`
    width: 100%;
    height: auto;
    max-width: 430px;
    padding: 16px 0;

    gap: 24px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    @media (max-width: 1024px){
      flex-wrap: wrap;
    }
`;

export const ContainerMethod = styled.div`
  width: 100%;
  height: auto;

  gap: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px){
    flex-wrap: wrap;
  }
`;

export const CardPlansHeader = styled.div`
  width: 100%;
  height: auto;
  min-height: 170px;

  display: flex;
  align-items: center;
  flex-direction: column;

  >p:nth-of-type(1){
    text-align: center;
    white-space: nowrap;
  }

  >p:nth-of-type(2){
    text-align: center;
  }
`;

export const Button = styled.button`
    all: unset;
    width: 100%;
    height: 3rem;
    padding: 14px 0;
    max-height: 20px;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 1rem;
    background-color: #589BFF14;

    >img{
        width: 1.25rem;
        height: 1.25rem;
    }

    >p{
        cursor: pointer; 
    }

    :hover{
        opacity: 0.7;
    }
`;
